/** Base surface for a V2 dropdown Paper (SelectMenu's Popover, AppMenu's Menu, the MuiMenu theme override, …). */
export const getDropdownSurfaceBackground = (theme) => theme.palette.mode === 'dark'
    ? theme.palette.custom.OV.sys.surfaceContainer
    : theme.palette.custom.OV.sys.surfaceContainerLowest;
/** Hover/selected row background for a V2 dropdown menu item. */
export const getDropdownSurfaceActiveBackground = (theme) => theme.palette.mode === 'dark'
    ? theme.palette.custom.OV.sys.surfaceContainerHighest
    : theme.palette.custom.OV.sys.surfaceContainer;
